module.exports = __webpack_public_path__ + "static/media/momPillow.f4c2062e.jpg";